import { Fragment } from "react";
import { Avatar, Box, Divider, Typography, Chip, Card, Paper, useTheme } from "@mui/material";
import FechaFunction from "../../function/FechaFunction";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import InputReadQuill from "../richText/InputReadQuill";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import GroupIcon from '@mui/icons-material/Group';
import SyncIcon from '@mui/icons-material/Sync';

const LogsCard = ({
  item,
  keyst
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  let texto;
  let actionType = '';
  let actionColor = '#718096';
  let actionIcon = null;
  if(item){
      switch (item?.accion_lt || item?.accion_lc) {
          case 'ALTA':
              texto=`creó el ticket`;
              actionType = 'ALTA';
              actionColor = '#10b981';
              actionIcon = <AddCircleIcon sx={{ fontSize: 16 }} />;
              break;
          case 'CIERRE':
              texto=`realizó el cierre del ticket`;
              actionType = 'CIERRE';
              actionColor = '#6366f1';
              actionIcon = <LockIcon sx={{ fontSize: 16 }} />;
              break;
          case 'REABRIO':
              texto=`abrió nuevamente el ticket`;
              actionType = 'RE-APERTURA';
              actionColor = '#f59e0b';
              actionIcon = <LockOpenIcon sx={{ fontSize: 16 }} />;
              break;
          case 'ASIGNOP':
              texto=`asignó el ticket a ${item?.asignoNombre_p || item?.creadoNombre_p}`;
              actionType = 'ASIGNACION';
              actionColor = '#0364ff';
              actionIcon = <AssignmentIndIcon sx={{ fontSize: 16 }} />;
              break;
          case 'ASIGNOG':
              texto=`asignó el ticket al grupo ${item?.asignoNombre_g || item?.creadoNombre_g}`;
              actionType = 'ASIGNACION';
              actionColor = '#8b5cf6';
              actionIcon = <GroupIcon sx={{ fontSize: 16 }} />;
              break;
          case 'RESOLUCION':
              texto=`realizó la resolución del ticket`;
              actionType = 'RESOLUCIÓN';
              actionColor = '#10b981';
              actionIcon = <LockIcon sx={{ fontSize: 16 }} />;
              break;
          case 'MODIFICO':
              texto=`realizó modificaciones en el ticket`;
              actionType = 'MODIFICACION';
              actionColor = '#f59e0b';
              actionIcon = <EditIcon sx={{ fontSize: 16 }} />;
              break;
          case 'REAPERTURA':
              texto=`realizó la reapertura del ticket`;
              actionType = 'REAPERTURA';
              actionColor = '#f59e0b';
              actionIcon = <LockOpenIcon sx={{ fontSize: 16 }} />;
              break;
          case 'MODIFICOLC':
              texto=`realizó modificaciones en el contacto`;
              actionType = 'MODIFICACION';
              actionColor = '#f59e0b';
              actionIcon = <EditIcon sx={{ fontSize: 16 }} />;
              break;
          case 'MODIFICODIRENTLC':
              texto=`realizó modificaciones en el servicio`;
              actionType = 'MODIFICACION';
              actionColor = '#f59e0b';
              actionIcon = <EditIcon sx={{ fontSize: 16 }} />;
              break;
          case 'ALTACONSULTALC':
              texto=`realizó el alta del contacto por consulta externa`;
              actionType = 'ALTA';
              actionColor = '#10b981';
              actionIcon = <AddCircleIcon sx={{ fontSize: 16 }} />;
              break;
          case 'ALTALC':
              texto=`realizó el alta del contacto`;
              actionType = 'ALTA';
              actionColor = '#10b981';
              actionIcon = <AddCircleIcon sx={{ fontSize: 16 }} />;
              break;
          case 'FNACIMIENTOLC':
              texto=`cargó la fecha de nacimiento`;
              actionType = 'MODIFICACION';
              actionColor = '#f59e0b';
              actionIcon = <EditIcon sx={{ fontSize: 16 }} />;
              break;
          case 'IMGLC':
              texto=`cargó las imágenes del documento`;
              actionType = 'IMAGENES';
              actionColor = '#0ea5e9';
              actionIcon = <AddCircleIcon sx={{ fontSize: 16 }} />;
              break;
          case 'CONSTAFIPLC':
              texto=`cargó la constancia de AFIP`;
              actionType = 'AFIP';
              actionColor = '#0ea5e9';
              actionIcon = <AddCircleIcon sx={{ fontSize: 16 }} />;
              break;
          case 'PLANTILLAINI':
              texto=`usó una plantilla de ticket`;
              actionType = 'PLANTILLA';
              actionColor = '#8b5cf6';
              actionIcon = <EditIcon sx={{ fontSize: 16 }} />;
              break;
          default:
              texto = item?.accion_lt || item?.accion_lc || '';
              actionType = 'OTRO';
              actionColor = '#718096';
              actionIcon = <EditIcon sx={{ fontSize: 16 }} />;
              break;
      }
      if(item?.servicioId_lc){
          texto = `Servicio #${item?.servicioId_lc} - ${texto}`;
      }else if(item?.preServicioId_lc){
          texto = `Pre-Servicio #${item?.preServicioId_lc} - ${texto}`;
      }
  }
  return (
    <Card
      key={keyst}
      sx={{
        mb: 2,
        p: 2.5,
        borderRadius: 2,
        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed',
        background: isDarkMode ? '#2d3a52 !important' : '#ffffff !important',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: isDarkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.08)',
          borderColor: actionColor + '40'
        },
        boxShadow: 4
      }}
    >
      {/* Header con Avatar y Acción */}
      <Box display='flex' alignItems='center' justifyContent='space-between' mb={2}>
        <Box display='flex' alignItems='center' gap={1.5}>
          {/* Avatar con borde de color */}
          <Box
            sx={{
              p: 0.3,
              borderRadius: '50%',
              background: `${actionColor}20`,
              border: `2px solid ${actionColor}40`
            }}
          >
            <Avatar
              src={item?.creadoFoto_p}
              sx={{
                width: 36,
                height: 36,
                background: isDarkMode ? '#1F2A40' : '#f1f3f5',
                border: isDarkMode ? '2px solid #2d3a52' : '2px solid #fff'
              }}
            />
          </Box>
          {/* Información del usuario y acción */}
          <Box>
            <Box display='flex' alignItems='center' gap={0.5} flexWrap='wrap'>
              <Typography
                  sx={{
                      color: isDarkMode ? '#e0e0e0' : '#2d3748',
                      fontWeight: 600,
                      fontSize: 14,
                      lineHeight: 1.2
                  }}
              >
                  {item?.creado?.nombre_p || item?.creadoNombre_p}
              </Typography>
              <Chip
                label="Autor"
                size="small"
                sx={{
                  height: 18,
                  fontSize: 10,
                  fontWeight: 600,
                  backgroundColor: isDarkMode ? '#1F2A40' : '#f1f3f5',
                  color: isDarkMode ? '#b0bec5' : '#718096',
                  '& .MuiChip-label': { px: 1 }
                }}
              />
              {(item?.isMigrated_lc === 1 || item?.isMigrated_lc === true) && (
                <Chip
                  icon={<SyncIcon sx={{ fontSize: 12 }} />}
                  label="Migrado"
                  size="small"
                  sx={{
                    height: 18,
                    fontSize: 10,
                    fontWeight: 600,
                    backgroundColor: isDarkMode ? '#1a3a5c' : '#dbeafe',
                    color: isDarkMode ? '#90caf9' : '#1e40af',
                    border: isDarkMode ? '1px solid #3d4a62' : '1px solid #93c5fd',
                    '& .MuiChip-label': { px: 1 },
                    '& .MuiChip-icon': {
                      color: isDarkMode ? '#90caf9' : '#1e40af',
                      ml: 0.5,
                      mr: -0.5
                    }
                  }}
                />
              )}
            </Box>
            <Typography
                sx={{
                    color: isDarkMode ? '#b0bec5' : '#4a5568',
                    fontSize: 13,
                    mt: 0.3,
                    lineHeight: 1.4
                }}
            >
                {texto}
            </Typography>
          </Box>
        </Box>
        {/* Badge de tipo de acción */}
        {actionIcon && (
          <Chip
            icon={actionIcon}
            label={actionType}
            size="small"
            sx={{
              height: 24,
              fontSize: 11,
              fontWeight: 600,
              backgroundColor: `${actionColor}15`,
              color: actionColor,
              border: `1px solid ${actionColor}40`,
              '& .MuiChip-icon': {
                color: actionColor,
                ml: 1
              }
            }}
          />
        )}
      </Box>

      {/* Tabla de cambios - manteniendo el TableBody original */}
      {item?.logs?.length > 0 && (
        <Box mt={2}>
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: 'none',
              border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed',
              borderRadius: 2,
              overflow: 'hidden',
              backgroundColor: isDarkMode ? '#1F2A40' : '#fff'
            }}
          >
            <Table aria-label="simple table" sx={{border: 2,borderColor: isDarkMode ? '#3d4a62' : 'gray',borderCollapse: 'unset',borderRadius:2}}>
              <TableHead>
                <TableRow className='table-header-row'>
                  <TableCell align="center" sx={{background: isDarkMode ? '#1a3a5c !important' : '#e6f0ff !important',color: isDarkMode ? '#e0e0e0 !important' : '#15294b !important',fontWeight: 'bold',fontSize:13,borderTopLeftRadius:7,p:0,width: 15}}>Campo</TableCell>
                  <TableCell align="center" sx={{background: isDarkMode ? '#1a3a5c !important' : '#e6f0ff !important',color: isDarkMode ? '#e0e0e0 !important' : '#15294b !important',fontWeight: 'bold',fontSize:13,p:0,width: 150}}>
                    {(item?.accion_lt === 'PLANTILLAINI' || item?.accion_lc === 'PLANTILLAINI') ? 'Original' : 'Antes'}
                  </TableCell>
                  <TableCell align="center" sx={{background: isDarkMode ? '#1a3a5c !important' : '#e6f0ff !important',color: isDarkMode ? '#e0e0e0 !important' : '#15294b !important',fontWeight: 'bold',fontSize:13,borderTopRightRadius:7,p:0,width: 150}}>Ahora</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                { item?.logs?.map((lg, idx)=>(
                  <Fragment key={`${lg?.titulo}-${idx}`}>
                    {lg?.titulo === 'Cuerpo' ? (
                      <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: isDarkMode ? '#2d3a52' : 'transparent' }}
                      >
                        <TableCell align="center" sx={{p:0,color: isDarkMode ? '#e0e0e0' : '#000'}}>{lg?.titulo}</TableCell>
                        <TableCell align="center" sx={{p:0,color: isDarkMode ? '#e0e0e0' : '#000'}}><InputReadQuill template={lg.old || '-'} /></TableCell>
                        <TableCell align="center" sx={{p:0,color: isDarkMode ? '#e0e0e0' : '#000'}}><InputReadQuill template={lg.nuevo || '-'} /></TableCell>
                      </TableRow>
                    ):(
                      <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: isDarkMode ? '#2d3a52' : 'transparent' }}
                      >
                        <TableCell align="center" sx={{p:0,color: isDarkMode ? '#e0e0e0' : '#000'}}>{lg?.titulo}</TableCell>
                        <TableCell align="center" sx={{p:0,color: isDarkMode ? '#e0e0e0' : '#000'}}>{lg.old}</TableCell>
                        <TableCell align="center" sx={{p:0,color: isDarkMode ? '#e0e0e0' : '#000'}}>{lg.nuevo}</TableCell>
                      </TableRow>
                    )}
                  </Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {/* Footer con timestamp */}
      <Box
        display='flex'
        alignItems='center'
        justifyContent='flex-end'
        gap={0.5}
        mt={2}
        pt={1.5}
        borderTop={isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed'}
      >
        <AccessTimeIcon sx={{ fontSize: 14, color: isDarkMode ? '#b0bec5' : '#9ca3af' }} />
        <Typography
          sx={{
            color: isDarkMode ? '#b0bec5' : '#9ca3af',
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: 0.3
          }}
        >
          {FechaFunction.format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm:ss')}
        </Typography>
      </Box>
    </Card>
  );
}

export default LogsCard;
